// WARNING: Fichier généré automatiquement depuis noff.gg
// Ne PAS éditer à la main. Modifie plutôt scripts/build-brawlers.ts puis relance le script.
// Source : https://www.noff.gg/brawl-stars/brawlers
// Generated at: 2026-02-28T17:04:54.893Z

export type BrawlerRarity = 'Epic' | 'Legendary' | 'Mythic' | 'Rare' | 'Starting Brawler' | 'Super Rare' | 'Ultra Legendary';
export type BrawlerClass = 'Artillery' | 'Assassin' | 'Controller' | 'Damage Dealer' | 'Marksman' | 'Support' | 'Tank';
export type BrawlerMovement = 'Fast' | 'Normal' | 'Slow' | 'Very Fast' | 'Very Slow';
export type BrawlerRange = 'Long' | 'Normal' | 'Short' | 'Very Long';
export type BrawlerReload = 'Fast' | 'Normal' | 'Slow' | 'Very Fast' | 'Very Slow';

export type Brawler = {
  id: string;              // slug unique (dérivé de la clé)
  key: string;             // clé originale (ex: "el primo", "8-bit")
  slug: string;            // version kebab-case ("el-primo", "8-bit")
  name: string;            // version "humaine" ("El Primo", "8-Bit")
  imagePath: string | null;// /brawler/<filename> ou null si pas d'image
  rarity: BrawlerRarity;
  class: BrawlerClass;
  movement: BrawlerMovement;
  range: BrawlerRange;
  reload: BrawlerReload;
  released: number;        // année (ex: 2019)
};

export const BRAWLERS: Brawler[] = [
  {
    "id": "8-bit",
    "key": "8-bit",
    "slug": "8-bit",
    "name": "8-Bit",
    "imagePath": "/brawler/8_bit.webp",
    "rarity": "Super Rare",
    "class": "Damage Dealer",
    "movement": "Very Slow",
    "range": "Very Long",
    "reload": "Normal",
    "released": 2019
  },
  {
    "id": "alli",
    "key": "alli",
    "slug": "alli",
    "name": "Alli",
    "imagePath": "/brawler/alli.webp",
    "rarity": "Mythic",
    "class": "Assassin",
    "movement": "Fast",
    "range": "Short",
    "reload": "Normal",
    "released": 2025
  },
  {
    "id": "amber",
    "key": "amber",
    "slug": "amber",
    "name": "Amber",
    "imagePath": "/brawler/amber.webp",
    "rarity": "Legendary",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Very Fast",
    "released": 2020
  },
  {
    "id": "angelo",
    "key": "angelo",
    "slug": "angelo",
    "name": "Angelo",
    "imagePath": "/brawler/angelo.webp",
    "rarity": "Epic",
    "class": "Marksman",
    "movement": "Very Fast",
    "range": "Very Long",
    "reload": "Very Fast",
    "released": 2024
  },
  {
    "id": "ash",
    "key": "ash",
    "slug": "ash",
    "name": "Ash",
    "imagePath": "/brawler/ash.webp",
    "rarity": "Epic",
    "class": "Tank",
    "movement": "Normal",
    "range": "Normal",
    "reload": "Fast",
    "released": 2021
  },
  {
    "id": "barley",
    "key": "barley",
    "slug": "barley",
    "name": "Barley",
    "imagePath": "/brawler/barley.webp",
    "rarity": "Rare",
    "class": "Artillery",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2017
  },
  {
    "id": "bea",
    "key": "bea",
    "slug": "bea",
    "name": "Bea",
    "imagePath": "/brawler/bea.webp",
    "rarity": "Epic",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Very Fast",
    "released": 2019
  },
  {
    "id": "belle",
    "key": "belle",
    "slug": "belle",
    "name": "Belle",
    "imagePath": "/brawler/belle.webp",
    "rarity": "Epic",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Fast",
    "released": 2021
  },
  {
    "id": "berry",
    "key": "berry",
    "slug": "berry",
    "name": "Berry",
    "imagePath": "/brawler/berry.webp",
    "rarity": "Epic",
    "class": "Support",
    "movement": "Normal",
    "range": "Normal",
    "reload": "Very Slow",
    "released": 2024
  },
  {
    "id": "bibi",
    "key": "bibi",
    "slug": "bibi",
    "name": "Bibi",
    "imagePath": "/brawler/bibi.webp",
    "rarity": "Epic",
    "class": "Tank",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2019
  },
  {
    "id": "bo",
    "key": "bo",
    "slug": "bo",
    "name": "Bo",
    "imagePath": "/brawler/bo.webp",
    "rarity": "Epic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2017
  },
  {
    "id": "bonnie",
    "key": "bonnie",
    "slug": "bonnie",
    "name": "Bonnie",
    "imagePath": "/brawler/bonnie.webp",
    "rarity": "Epic",
    "class": "Marksman",
    "movement": "Slow",
    "range": "Long",
    "reload": "Very Fast",
    "released": 2022
  },
  {
    "id": "brock",
    "key": "brock",
    "slug": "brock",
    "name": "Brock",
    "imagePath": "/brawler/brock.webp",
    "rarity": "Rare",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2017
  },
  {
    "id": "bull",
    "key": "bull",
    "slug": "bull",
    "name": "Bull",
    "imagePath": "/brawler/bull.webp",
    "rarity": "Rare",
    "class": "Tank",
    "movement": "Fast",
    "range": "Normal",
    "reload": "Normal",
    "released": 2017
  },
  {
    "id": "buster",
    "key": "buster",
    "slug": "buster",
    "name": "Buster",
    "imagePath": "/brawler/buster.webp",
    "rarity": "Mythic",
    "class": "Tank",
    "movement": "Fast",
    "range": "Normal",
    "reload": "Normal",
    "released": 2022
  },
  {
    "id": "buzz",
    "key": "buzz",
    "slug": "buzz",
    "name": "Buzz",
    "imagePath": "/brawler/buzz.webp",
    "rarity": "Mythic",
    "class": "Assassin",
    "movement": "Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2021
  },
  {
    "id": "byron",
    "key": "byron",
    "slug": "byron",
    "name": "Byron",
    "imagePath": "/brawler/byron.webp",
    "rarity": "Mythic",
    "class": "Support",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Fast",
    "released": 2020
  },
  {
    "id": "carl",
    "key": "carl",
    "slug": "carl",
    "name": "Carl",
    "imagePath": "/brawler/carl.webp",
    "rarity": "Super Rare",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2019
  },
  {
    "id": "charlie",
    "key": "charlie",
    "slug": "charlie",
    "name": "Charlie",
    "imagePath": "/brawler/charlie.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2023
  },
  {
    "id": "chester",
    "key": "chester",
    "slug": "chester",
    "name": "Chester",
    "imagePath": "/brawler/chester.webp",
    "rarity": "Legendary",
    "class": "Damage Dealer",
    "movement": "Fast",
    "range": "Long",
    "reload": "Normal",
    "released": 2022
  },
  {
    "id": "chuck",
    "key": "chuck",
    "slug": "chuck",
    "name": "Chuck",
    "imagePath": "/brawler/chuck.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Fast",
    "range": "Normal",
    "reload": "Slow",
    "released": 2023
  },
  {
    "id": "clancy",
    "key": "clancy",
    "slug": "clancy",
    "name": "Clancy",
    "imagePath": "/brawler/clancy.webp",
    "rarity": "Mythic",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2024
  },
  {
    "id": "colette",
    "key": "colette",
    "slug": "colette",
    "name": "Colette",
    "imagePath": "/brawler/colette.webp",
    "rarity": "Epic",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2020
  },
  {
    "id": "colt",
    "key": "colt",
    "slug": "colt",
    "name": "Colt",
    "imagePath": "/brawler/colt.webp",
    "rarity": "Rare",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Fast",
    "released": 2017
  },
  {
    "id": "cordelius",
    "key": "cordelius",
    "slug": "cordelius",
    "name": "Cordelius",
    "imagePath": "/brawler/cordelius.webp",
    "rarity": "Legendary",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Normal",
    "reload": "Very Fast",
    "released": 2023
  },
  {
    "id": "crow",
    "key": "crow",
    "slug": "crow",
    "name": "Crow",
    "imagePath": "/brawler/crow.webp",
    "rarity": "Legendary",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Long",
    "reload": "Fast",
    "released": 2017
  },
  {
    "id": "darryl",
    "key": "darryl",
    "slug": "darryl",
    "name": "Darryl",
    "imagePath": "/brawler/darryl.webp",
    "rarity": "Super Rare",
    "class": "Tank",
    "movement": "Fast",
    "range": "Normal",
    "reload": "Normal",
    "released": 2017
  },
  {
    "id": "doug",
    "key": "doug",
    "slug": "doug",
    "name": "Doug",
    "imagePath": "/brawler/doug.webp",
    "rarity": "Mythic",
    "class": "Support",
    "movement": "Fast",
    "range": "Short",
    "reload": "Normal",
    "released": 2023
  },
  {
    "id": "draco",
    "key": "draco",
    "slug": "draco",
    "name": "Draco",
    "imagePath": "/brawler/draco.webp",
    "rarity": "Legendary",
    "class": "Tank",
    "movement": "Normal",
    "range": "Normal",
    "reload": "Normal",
    "released": 2024
  },
  {
    "id": "dynamike",
    "key": "dynamike",
    "slug": "dynamike",
    "name": "Dynamike",
    "imagePath": "/brawler/dynamike.webp",
    "rarity": "Super Rare",
    "class": "Artillery",
    "movement": "Fast",
    "range": "Long",
    "reload": "Normal",
    "released": 2017
  },
  {
    "id": "edgar",
    "key": "edgar",
    "slug": "edgar",
    "name": "Edgar",
    "imagePath": "/brawler/edgar.webp",
    "rarity": "Epic",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2020
  },
  {
    "id": "el-primo",
    "key": "el primo",
    "slug": "el-primo",
    "name": "El Primo",
    "imagePath": "/brawler/el_primo.webp",
    "rarity": "Rare",
    "class": "Tank",
    "movement": "Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2017
  },
  {
    "id": "emz",
    "key": "emz",
    "slug": "emz",
    "name": "Emz",
    "imagePath": "/brawler/emz.webp",
    "rarity": "Epic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Normal",
    "reload": "Slow",
    "released": 2019
  },
  {
    "id": "eve",
    "key": "eve",
    "slug": "eve",
    "name": "Eve",
    "imagePath": "/brawler/eve.webp",
    "rarity": "Mythic",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Normal",
    "released": 2022
  },
  {
    "id": "fang",
    "key": "fang",
    "slug": "fang",
    "name": "Fang",
    "imagePath": "/brawler/fang.webp",
    "rarity": "Mythic",
    "class": "Assassin",
    "movement": "Fast",
    "range": "Very Long",
    "reload": "Very Fast",
    "released": 2022
  },
  {
    "id": "finx",
    "key": "finx",
    "slug": "finx",
    "name": "Finx",
    "imagePath": "/brawler/finx.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2025
  },
  {
    "id": "frank",
    "key": "frank",
    "slug": "frank",
    "name": "Frank",
    "imagePath": "/brawler/frank.webp",
    "rarity": "Epic",
    "class": "Tank",
    "movement": "Fast",
    "range": "Normal",
    "reload": "Very Fast",
    "released": 2018
  },
  {
    "id": "gale",
    "key": "gale",
    "slug": "gale",
    "name": "Gale",
    "imagePath": "/brawler/gale.webp",
    "rarity": "Epic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Very Fast",
    "released": 2020
  },
  {
    "id": "gene",
    "key": "gene",
    "slug": "gene",
    "name": "Gene",
    "imagePath": "/brawler/gene.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Slow",
    "released": 2019
  },
  {
    "id": "gigi",
    "key": "gigi",
    "slug": "gigi",
    "name": "Gigi",
    "imagePath": "/brawler/gigi.webp",
    "rarity": "Mythic",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2025
  },
  {
    "id": "glowy",
    "key": "glowy",
    "slug": "glowy",
    "name": "Glowy",
    "imagePath": "/brawler/glowbert.webp",
    "rarity": "Mythic",
    "class": "Support",
    "movement": "Fast",
    "range": "Long",
    "reload": "Normal",
    "released": 2025
  },
  {
    "id": "gray",
    "key": "gray",
    "slug": "gray",
    "name": "Gray",
    "imagePath": "/brawler/gray.webp",
    "rarity": "Mythic",
    "class": "Support",
    "movement": "Normal",
    "range": "Long",
    "reload": "Fast",
    "released": 2023
  },
  {
    "id": "griff",
    "key": "griff",
    "slug": "griff",
    "name": "Griff",
    "imagePath": "/brawler/griff.webp",
    "rarity": "Epic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2021
  },
  {
    "id": "grom",
    "key": "grom",
    "slug": "grom",
    "name": "Grom",
    "imagePath": "/brawler/grom.webp",
    "rarity": "Epic",
    "class": "Artillery",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2021
  },
  {
    "id": "gus",
    "key": "gus",
    "slug": "gus",
    "name": "Gus",
    "imagePath": "/brawler/gus.webp",
    "rarity": "Super Rare",
    "class": "Support",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Normal",
    "released": 2022
  },
  {
    "id": "hank",
    "key": "hank",
    "slug": "hank",
    "name": "Hank",
    "imagePath": "/brawler/hank.webp",
    "rarity": "Epic",
    "class": "Tank",
    "movement": "Normal",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2023
  },
  {
    "id": "jacky",
    "key": "jacky",
    "slug": "jacky",
    "name": "Jacky",
    "imagePath": "/brawler/jacky.webp",
    "rarity": "Super Rare",
    "class": "Tank",
    "movement": "Fast",
    "range": "Short",
    "reload": "Normal",
    "released": 2020
  },
  {
    "id": "jae-yong",
    "key": "jae-yong",
    "slug": "jae-yong",
    "name": "Jae-yong",
    "imagePath": "/brawler/jae_yong.webp",
    "rarity": "Mythic",
    "class": "Support",
    "movement": "Fast",
    "range": "Long",
    "reload": "Fast",
    "released": 2025
  },
  {
    "id": "janet",
    "key": "janet",
    "slug": "janet",
    "name": "Janet",
    "imagePath": "/brawler/janet.webp",
    "rarity": "Mythic",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Normal",
    "reload": "Normal",
    "released": 2022
  },
  {
    "id": "jessie",
    "key": "jessie",
    "slug": "jessie",
    "name": "Jessie",
    "imagePath": "/brawler/jessie.webp",
    "rarity": "Super Rare",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2017
  },
  {
    "id": "juju",
    "key": "juju",
    "slug": "juju",
    "name": "Juju",
    "imagePath": "/brawler/juju.webp",
    "rarity": "Mythic",
    "class": "Artillery",
    "movement": "Very Fast",
    "range": "Normal",
    "reload": "Normal",
    "released": 2024
  },
  {
    "id": "kaze",
    "key": "kaze",
    "slug": "kaze",
    "name": "Kaze",
    "imagePath": "/brawler/kaze.webp",
    "rarity": "Ultra Legendary",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2025
  },
  {
    "id": "kenji",
    "key": "kenji",
    "slug": "kenji",
    "name": "Kenji",
    "imagePath": "/brawler/kenji.webp",
    "rarity": "Legendary",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2024
  },
  {
    "id": "kit",
    "key": "kit",
    "slug": "kit",
    "name": "Kit",
    "imagePath": "/brawler/kit.webp",
    "rarity": "Legendary",
    "class": "Support",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2024
  },
  {
    "id": "larry-lawrie",
    "key": "larry & lawrie",
    "slug": "larry-lawrie",
    "name": "Larry & Lawrie",
    "imagePath": "/brawler/larry_and_lawrie.webp",
    "rarity": "Epic",
    "class": "Artillery",
    "movement": "Fast",
    "range": "Long",
    "reload": "Very Slow",
    "released": 2024
  },
  {
    "id": "leon",
    "key": "leon",
    "slug": "leon",
    "name": "Leon",
    "imagePath": "/brawler/leon.webp",
    "rarity": "Legendary",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Very Long",
    "reload": "Normal",
    "released": 2018
  },
  {
    "id": "lily",
    "key": "lily",
    "slug": "lily",
    "name": "Lily",
    "imagePath": "/brawler/lily.webp",
    "rarity": "Mythic",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2024
  },
  {
    "id": "lola",
    "key": "lola",
    "slug": "lola",
    "name": "Lola",
    "imagePath": "/brawler/lola.webp",
    "rarity": "Epic",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2021
  },
  {
    "id": "lou",
    "key": "lou",
    "slug": "lou",
    "name": "Lou",
    "imagePath": "/brawler/lou.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Very Fast",
    "released": 2020
  },
  {
    "id": "lumi",
    "key": "lumi",
    "slug": "lumi",
    "name": "Lumi",
    "imagePath": "/brawler/lumi.webp",
    "rarity": "Mythic",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Very Fast",
    "released": 2025
  },
  {
    "id": "maisie",
    "key": "maisie",
    "slug": "maisie",
    "name": "Maisie",
    "imagePath": "/brawler/maisie.webp",
    "rarity": "Epic",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2023
  },
  {
    "id": "mandy",
    "key": "mandy",
    "slug": "mandy",
    "name": "Mandy",
    "imagePath": "/brawler/mandy.webp",
    "rarity": "Epic",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2023
  },
  {
    "id": "max",
    "key": "max",
    "slug": "max",
    "name": "Max",
    "imagePath": "/brawler/max.webp",
    "rarity": "Mythic",
    "class": "Support",
    "movement": "Very Fast",
    "range": "Long",
    "reload": "Very Fast",
    "released": 2019
  },
  {
    "id": "meeple",
    "key": "meeple",
    "slug": "meeple",
    "name": "Meeple",
    "imagePath": "/brawler/meeple.webp",
    "rarity": "Epic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2025
  },
  {
    "id": "meg",
    "key": "meg",
    "slug": "meg",
    "name": "Meg",
    "imagePath": "/brawler/meg.webp",
    "rarity": "Legendary",
    "class": "Tank",
    "movement": "Fast",
    "range": "Long",
    "reload": "Very Fast",
    "released": 2021
  },
  {
    "id": "melodie",
    "key": "melodie",
    "slug": "melodie",
    "name": "Melodie",
    "imagePath": "/brawler/melodie.webp",
    "rarity": "Mythic",
    "class": "Assassin",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2024
  },
  {
    "id": "mico",
    "key": "mico",
    "slug": "mico",
    "name": "Mico",
    "imagePath": "/brawler/mico.webp",
    "rarity": "Mythic",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Normal",
    "reload": "Very Slow",
    "released": 2023
  },
  {
    "id": "mina",
    "key": "mina",
    "slug": "mina",
    "name": "Mina",
    "imagePath": "/brawler/mina.webp",
    "rarity": "Mythic",
    "class": "Damage Dealer",
    "movement": "Fast",
    "range": "Long",
    "reload": "Normal",
    "released": 2025
  },
  {
    "id": "moe",
    "key": "moe",
    "slug": "moe",
    "name": "Moe",
    "imagePath": "/brawler/moe.webp",
    "rarity": "Mythic",
    "class": "Damage Dealer",
    "movement": "Fast",
    "range": "Long",
    "reload": "Normal",
    "released": 2024
  },
  {
    "id": "mortis",
    "key": "mortis",
    "slug": "mortis",
    "name": "Mortis",
    "imagePath": "/brawler/mortis.webp",
    "rarity": "Mythic",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Slow",
    "released": 2017
  },
  {
    "id": "mr-p",
    "key": "mr. p",
    "slug": "mr-p",
    "name": "Mr. P",
    "imagePath": "/brawler/mr_p.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2020
  },
  {
    "id": "nani",
    "key": "nani",
    "slug": "nani",
    "name": "Nani",
    "imagePath": "/brawler/nani.webp",
    "rarity": "Epic",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2020
  },
  {
    "id": "nita",
    "key": "nita",
    "slug": "nita",
    "name": "Nita",
    "imagePath": "/brawler/nita.webp",
    "rarity": "Rare",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Normal",
    "reload": "Very Fast",
    "released": 2017
  },
  {
    "id": "ollie",
    "key": "ollie",
    "slug": "ollie",
    "name": "Ollie",
    "imagePath": "/brawler/ollie.webp",
    "rarity": "Mythic",
    "class": "Tank",
    "movement": "Fast",
    "range": "Normal",
    "reload": "Normal",
    "released": 2025
  },
  {
    "id": "otis",
    "key": "otis",
    "slug": "otis",
    "name": "Otis",
    "imagePath": "/brawler/otis.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2022
  },
  {
    "id": "pam",
    "key": "pam",
    "slug": "pam",
    "name": "Pam",
    "imagePath": "/brawler/pam.webp",
    "rarity": "Epic",
    "class": "Support",
    "movement": "Normal",
    "range": "Long",
    "reload": "Very Fast",
    "released": 2017
  },
  {
    "id": "pearl",
    "key": "pearl",
    "slug": "pearl",
    "name": "Pearl",
    "imagePath": "/brawler/pearl.webp",
    "rarity": "Epic",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2023
  },
  {
    "id": "penny",
    "key": "penny",
    "slug": "penny",
    "name": "Penny",
    "imagePath": "/brawler/penny.webp",
    "rarity": "Super Rare",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2018
  },
  {
    "id": "pierce",
    "key": "pierce",
    "slug": "pierce",
    "name": "Pierce",
    "imagePath": "/brawler/pierce.webp",
    "rarity": "Legendary",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Very Slow",
    "released": 2025
  },
  {
    "id": "piper",
    "key": "piper",
    "slug": "piper",
    "name": "Piper",
    "imagePath": "/brawler/piper.webp",
    "rarity": "Epic",
    "class": "Marksman",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Very Slow",
    "released": 2017
  },
  {
    "id": "poco",
    "key": "poco",
    "slug": "poco",
    "name": "Poco",
    "imagePath": "/brawler/poco.webp",
    "rarity": "Rare",
    "class": "Support",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2017
  },
  {
    "id": "r-t",
    "key": "r-t",
    "slug": "r-t",
    "name": "R-T",
    "imagePath": "/brawler/r_t.webp",
    "rarity": "Mythic",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Normal",
    "released": 2023
  },
  {
    "id": "rico",
    "key": "rico",
    "slug": "rico",
    "name": "Rico",
    "imagePath": "/brawler/rico.webp",
    "rarity": "Super Rare",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Very Long",
    "reload": "Very Fast",
    "released": 2017
  },
  {
    "id": "rosa",
    "key": "rosa",
    "slug": "rosa",
    "name": "Rosa",
    "imagePath": "/brawler/rosa.webp",
    "rarity": "Rare",
    "class": "Tank",
    "movement": "Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2019
  },
  {
    "id": "ruffs",
    "key": "ruffs",
    "slug": "ruffs",
    "name": "Ruffs",
    "imagePath": "/brawler/ruffs.webp",
    "rarity": "Mythic",
    "class": "Support",
    "movement": "Normal",
    "range": "Long",
    "reload": "Fast",
    "released": 2021
  },
  {
    "id": "sam",
    "key": "sam",
    "slug": "sam",
    "name": "Sam",
    "imagePath": "/brawler/sam.webp",
    "rarity": "Epic",
    "class": "Assassin",
    "movement": "Fast",
    "range": "Short",
    "reload": "Normal",
    "released": 2022
  },
  {
    "id": "sandy",
    "key": "sandy",
    "slug": "sandy",
    "name": "Sandy",
    "imagePath": "/brawler/sandy.webp",
    "rarity": "Legendary",
    "class": "Controller",
    "movement": "Fast",
    "range": "Normal",
    "reload": "Normal",
    "released": 2019
  },
  {
    "id": "shade",
    "key": "shade",
    "slug": "shade",
    "name": "Shade",
    "imagePath": "/brawler/shade.webp",
    "rarity": "Epic",
    "class": "Assassin",
    "movement": "Very Fast",
    "range": "Short",
    "reload": "Very Fast",
    "released": 2024
  },
  {
    "id": "shelly",
    "key": "shelly",
    "slug": "shelly",
    "name": "Shelly",
    "imagePath": "/brawler/shelly.webp",
    "rarity": "Starting Brawler",
    "class": "Damage Dealer",
    "movement": "Fast",
    "range": "Long",
    "reload": "Normal",
    "released": 2017
  },
  {
    "id": "sirius",
    "key": "sirius",
    "slug": "sirius",
    "name": "Sirius",
    "imagePath": "/brawler/sirius.webp",
    "rarity": "Ultra Legendary",
    "class": "Controller",
    "movement": "Fast",
    "range": "Long",
    "reload": "Normal",
    "released": 2026
  },
  {
    "id": "spike",
    "key": "spike",
    "slug": "spike",
    "name": "Spike",
    "imagePath": "/brawler/spike.webp",
    "rarity": "Legendary",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2017
  },
  {
    "id": "sprout",
    "key": "sprout",
    "slug": "sprout",
    "name": "Sprout",
    "imagePath": "/brawler/sprout.webp",
    "rarity": "Mythic",
    "class": "Artillery",
    "movement": "Normal",
    "range": "Normal",
    "reload": "Normal",
    "released": 2020
  },
  {
    "id": "squeak",
    "key": "squeak",
    "slug": "squeak",
    "name": "Squeak",
    "imagePath": "/brawler/squeak.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2021
  },
  {
    "id": "stu",
    "key": "stu",
    "slug": "stu",
    "name": "Stu",
    "imagePath": "/brawler/stu.webp",
    "rarity": "Epic",
    "class": "Assassin",
    "movement": "Normal",
    "range": "Long",
    "reload": "Normal",
    "released": 2021
  },
  {
    "id": "surge",
    "key": "surge",
    "slug": "surge",
    "name": "Surge",
    "imagePath": "/brawler/surge.webp",
    "rarity": "Legendary",
    "class": "Damage Dealer",
    "movement": "Slow",
    "range": "Normal",
    "reload": "Slow",
    "released": 2020
  },
  {
    "id": "tara",
    "key": "tara",
    "slug": "tara",
    "name": "Tara",
    "imagePath": "/brawler/tara.webp",
    "rarity": "Mythic",
    "class": "Damage Dealer",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2017
  },
  {
    "id": "tick",
    "key": "tick",
    "slug": "tick",
    "name": "Tick",
    "imagePath": "/brawler/tick.webp",
    "rarity": "Super Rare",
    "class": "Artillery",
    "movement": "Normal",
    "range": "Long",
    "reload": "Very Slow",
    "released": 2019
  },
  {
    "id": "trunk",
    "key": "trunk",
    "slug": "trunk",
    "name": "Trunk",
    "imagePath": "/brawler/trunk.webp",
    "rarity": "Epic",
    "class": "Tank",
    "movement": "Fast",
    "range": "Short",
    "reload": "Normal",
    "released": 2025
  },
  {
    "id": "willow",
    "key": "willow",
    "slug": "willow",
    "name": "Willow",
    "imagePath": "/brawler/willow.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Normal",
    "range": "Long",
    "reload": "Slow",
    "released": 2023
  },
  {
    "id": "ziggy",
    "key": "ziggy",
    "slug": "ziggy",
    "name": "Ziggy",
    "imagePath": "/brawler/ziggy.webp",
    "rarity": "Mythic",
    "class": "Controller",
    "movement": "Fast",
    "range": "Long",
    "reload": "Normal",
    "released": 2025
  }
] as const;
